var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "p",
      { staticClass: "label-subitem" },
      [
        _vm._v(_vm._s(_vm.validacao.label)),
        _c(
          "el-table",
          { attrs: { data: _vm.validacao.dados, "show-header": false } },
          [
            _c("el-table-column", { attrs: { prop: "campo" } }),
            _c("el-table-column", {
              attrs: { prop: "isValido", align: "left", width: "180" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      scope.row.valido
                        ? _c(
                            "div",
                            { staticClass: "valido" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "check", size: "lg" }
                              }),
                              _c("span", [_vm._v("  Válido")])
                            ],
                            1
                          )
                        : scope.row.valido === false
                        ? _c(
                            "div",
                            { staticClass: "invalido" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "times", size: "lg" }
                              }),
                              _c("span", [_vm._v("  Inválido")])
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e090c58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e090c58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppItemDespachoAutomatizadoValido.vue
// module id = null
// module chunks = 